/**
 * Provision mapping from numeric IDs to API provision strings
 */
export enum ProvisionApiMapping {
    Breakfast = 1,
    HalfBoard = 2,
    AllInclusive = 3,
    FullBoard = 4,
    NoMeal = 5,
}
